import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, Image, ButtonToolbar, Button } from 'react-bootstrap';

import { strings } from '../strings';

export class InterfaceForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            nameInputError: null
        }
    }

    // -----------------

    uploadImageSuccessCallback(result) {
        const { data } = this.state;

        data.url = result.url;

        this.setState({
            data: data
        });
    }

    // -----------------

    onChangeValue(e, property) {
        const { data } = this.state;

        data[property] = e.target.value;

        this.setState({
            data: data
        });
    }

    onSave() {
        if (this.validInput()) {
            const { data } = this.state;
            this.props.onSave(data);
        }
    }

    validInput() {
        let errors = 0;
        let namePtInputError = null;
        let imageInputError = null;

        const { data } = this.state;

        if ("" === data.namePt || null === data.namePt || undefined === data.namePt) {
            namePtInputError = 'error';
            errors++;
        }

        if ("" === data.url || null === data.url || undefined === data.url || 0 >= data.url.length) {
            imageInputError = 'error';
            errors++;
        }

        this.setState({
            namePtInputError: namePtInputError,
            imageInputError: imageInputError
        });

        return errors > 0 ? false : true;
    }

    // -------------------

    uploadImage(image) {
        this.props.onUploadImage(
            image,
            (a) => this.uploadImageSuccessCallback(a)
        );
    }

    removeImage() {
        const { data } = this.state;

        data.url = undefined;

        this.setState({
            data: data
        });
    }

    // -------------------

    renderImageFormControl(url) {
        if ("" === url || null === url || undefined === url || 0 >= url.length) {
            return (
                <FormControl type="file"
                    label={strings.upload}
                    accept=".png,.bmp,.svg,.jpg,.gif"
                    style={{ paddingTop: 7 }}
                    onChange={e => this.uploadImage(e.target.files[0])} />
            );
        }

        return (
            <div>
                <Image src={url} thumbnail style={{ maxWidth: 100, maxHeight: 100 }} />
                <Button style={{ verticalAlign: "bottom", marginLeft: 20 }} onClick={() => this.removeImage()}> {strings.removeImage} </Button>
            </div>
        );

    }

    render() {
        const { data, namePtInputError, imageInputError } = this.state;

        if (undefined === data || null === data) {
            return null;
        }

        const { title } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formNamePt" validationState={namePtInputError}>
                            <ControlLabel>{strings.namePtLong}</ControlLabel>
                            <FormControl
                                type="text"
                                value={data.namePt}
                                onChange={(e) => this.onChangeValue(e, "namePt")} />

                            <FormControl.Feedback />

                            {
                                namePtInputError !== null ?
                                    <HelpBlock> {strings.required} </HelpBlock> :
                                    null
                            }
                        </FormGroup>

                        <FormGroup controlId="formNameEn">
                            <ControlLabel>{strings.nameEnLong}</ControlLabel>
                            <FormControl
                                type="text"
                                value={data.nameEn}
                                onChange={(e) => this.onChangeValue(e, "nameEn")} />

                            <FormControl.Feedback />
                        </FormGroup>

                        <FormGroup controlId="formImage" validationState={imageInputError}>
                            <ControlLabel>{strings.image}</ControlLabel>
                            {this.renderImageFormControl(data.url)}
                            
                            {
                                imageInputError !== null ?
                                    <HelpBlock> {strings.required} </HelpBlock> :
                                    null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
